export class PolishLineDescriptionManager {

    constructor(private containerElement: JQuery) { }

    private amountOfSelectedLinesTextSpan : JQuery<HTMLElement>;
    private selectAllLinesCheckbox : JQuery<HTMLElement>;

    private polishOptionsContainer : JQuery<HTMLElement>;

    private restoreOriginalDescriptionButton : JQuery<HTMLElement>;
    private updateDescriptionButton : JQuery<HTMLElement>;

    private amountOfCharactersToRemoveInput : JQuery<HTMLElement>;

    private removeEverythingAtSelection : JQuery<HTMLElement>;
    private removeEverythingAtInput : JQuery<HTMLElement>;

    private insertFieldAtLocationWithSeperatorFieldSelection : JQuery<HTMLElement>;
    private insertFieldAtLocationWithSeperatorLocationSelection : JQuery<HTMLElement>;
    private insertFieldAtLocationWithSeperatorInput : JQuery<HTMLElement>;

    private textToReplaceInput : JQuery<HTMLElement>;
    private replacingTextInput : JQuery<HTMLElement>;

    private polishingInProgressContainer : JQuery<HTMLElement>;


    private linesTable : JQuery<HTMLElement>;
    private linesTableBody : JQuery<HTMLElement>;

    public initialize() {
        this.bindElements();
        this.bindEvents();
    }

    private bindElements() {
        var self = this;

        self.amountOfSelectedLinesTextSpan = self.containerElement.find('#amount-of-to-be-changed-lines-text');
        self.selectAllLinesCheckbox = this.containerElement.find('#select-all-checkbox');

        self.polishOptionsContainer = this.containerElement.find('#polish-options-container');

        self.restoreOriginalDescriptionButton = this.containerElement.find('#restore-original-description-button');
        self.updateDescriptionButton = this.containerElement.find('#update-description-button');

        self.amountOfCharactersToRemoveInput = this.containerElement.find('#polish-option-remove-first-x-characters-input');

        self.removeEverythingAtSelection = this.containerElement.find('#polish-option-remove-at-first-character-occurrence-select');
        self.removeEverythingAtInput = this.containerElement.find('#polish-option-remove-at-first-character-occurrence-input');

        self.textToReplaceInput = this.containerElement.find('#polish-option-replace-text-to-replace-input');
        self.replacingTextInput = this.containerElement.find('#polish-option-replace-text-with-text-to-replace-input');

        self.insertFieldAtLocationWithSeperatorFieldSelection = this.containerElement.find('#polish-option-insert-field-at-location-with-seperator-field-select');
        self.insertFieldAtLocationWithSeperatorLocationSelection = this.containerElement.find('#polish-option-insert-field-at-location-with-seperator-location-select');
        self.insertFieldAtLocationWithSeperatorInput = this.containerElement.find('#polish-option-insert-field-at-location-with-seperator-seperator-input');

        self.polishingInProgressContainer = this.containerElement.find('#polishing-in-progress-container');

        self.linesTable = this.containerElement.find('#lines-table');
        self.linesTableBody = self.linesTable.find('tbody');
    }

    private bindEvents() {
        var self = this;

        self.selectAllLinesCheckbox.off('change').on('change', () => {
            var isChecked = self.selectAllLinesCheckbox.is(':checked');
            self.linesTableBody.find('input[type="checkbox"]').prop( "checked", isChecked);
            self.updateTotalSelectedCount();
        })

        self.linesTableBody.find('tr').off('click').on('click', (e) => {
            if(!$(e.target).is('input:checkbox')) {
                e.preventDefault();
                e.stopImmediatePropagation();

                var checkbox = $(e.currentTarget).find('input[type="checkbox"]');
                checkbox.prop('checked', !checkbox.is(":checked"));
            }

            self.checkboxChanged();
        })

        self.restoreOriginalDescriptionButton.off('click').on('click', () => {
            var selectedLines = self.linesTableBody.find('tr').has('input[type="checkbox"]:checked');
            if(selectedLines.length == 0) {
                return;
            }

            if(selectedLines.length > 50) {
                self.startPolishing();
            }

            setTimeout(() => {
                selectedLines.each((index, element) => {
                    var tableRowToUpdate = $(element);

                    var originalDescription = tableRowToUpdate.data('original-description');
                    tableRowToUpdate.find('[data-description-td]').text(originalDescription);

                    var hiddenDescriptionInput = tableRowToUpdate.find('input:hidden[name$=".Description"]');

                    hiddenDescriptionInput.val(originalDescription);
                })
                
                self.finishPolishing()
            }, 1);
        })        
        
        self.updateDescriptionButton.off('click').on('click', () => {

            var selectedPolishOption = self.polishOptionsContainer.find("input[name='polish-options']:checked").val()?.toString();
            var selectedLines = self.linesTableBody.find('tr').has('input[type="checkbox"]:checked');
            if(selectedPolishOption == undefined || selectedPolishOption.length == 0 || selectedLines.length == 0) {
                return;
            }

            if(selectedLines.length > 50) {
                self.startPolishing();
            }
            
            setTimeout(() => {
                var amountOfCharactersToRemove = +(self.amountOfCharactersToRemoveInput.val()?.toString() ?? 0);
                if(amountOfCharactersToRemove < 0) { amountOfCharactersToRemove = 0; }

                var removeEverythingAtSelection = self.removeEverythingAtSelection.val()?.toString() ?? 'before';
                var removeEverythingAtCharacter = self.removeEverythingAtInput.val()?.toString() ?? '';

                var textToReplace = self.textToReplaceInput.val()?.toString() ?? '';
                var replacingText = self.replacingTextInput.val()?.toString() ?? '';

                var insertFieldAtLocationWithSeperatorField = self.insertFieldAtLocationWithSeperatorFieldSelection.val()?.toString() ?? '';
                var insertFieldAtLocationWithSeperatorLocation = self.insertFieldAtLocationWithSeperatorLocationSelection.val()?.toString() ?? '';
                var insertFieldAtLocationWithSeperator = self.insertFieldAtLocationWithSeperatorInput.val()?.toString() ?? '';

                selectedLines.each((index, element) => {
                    var tableRowToUpdate = $(element);
                    var descriptionRow = tableRowToUpdate.find('[data-description-td]');

                    var newDescription = descriptionRow.text();

                    switch(selectedPolishOption) {
                        case 'remove-first-x-characters':
                            newDescription = self.removeFirstCharactersFromString(amountOfCharactersToRemove, newDescription);
                            break;                    
                        case 'remove-at-first-character-occurrence':
                            newDescription = self.removeEverythingBeforeOrAfterCharactersFromString(removeEverythingAtSelection, removeEverythingAtCharacter, newDescription);
                            break;
                        case 'polish-option-replace-text-with-other-text':
                            newDescription = self.replaceTextFromString(textToReplace, replacingText, newDescription);
                            break;
                        case 'use-found-impa-description':
                            var impaDescription = tableRowToUpdate.data('impa-description');
                            if(impaDescription != undefined && impaDescription.length > 0) {
                                newDescription = impaDescription;
                            }
                            break;                    
                        case 'remove-upper-case-except-first-letter-of-every-word':
                            newDescription = self.removeUppercaseExceptFirstLetter(newDescription);
                            break;                    
                        case 'only-keep-the-first-sentence':
                            newDescription = self.onlyKeepTheFirstSentence(newDescription);
                            break;  
                        case 'remove-duplicate-sentences':
                            newDescription = self.removeDuplicateSentences(newDescription);
                            break;
                        case 'remove-repeated-phrases':
                            newDescription = self.removeRepeatedPhrases(newDescription);
                            break;                        
                        case 'insert-field-at-location-with-seperator':
                            newDescription = 
                                self.insertFieldAtLocationWithSeperator(insertFieldAtLocationWithSeperatorField, insertFieldAtLocationWithSeperatorLocation, 
                                                                        insertFieldAtLocationWithSeperator, tableRowToUpdate, newDescription);
                            break;
                    }

                    tableRowToUpdate.find('[data-description-td]').text(newDescription);

                    var hiddenDescriptionInput = tableRowToUpdate.find('input:hidden[name$=".Description"]');

                    hiddenDescriptionInput.val(newDescription);
                })
                
                self.finishPolishing()
            }, 1);
        })

    }

    //#region Polish options

    private startPolishing() {
        var self = this;

        self.polishingInProgressContainer.removeClass('d-none');
        self.linesTable.parent().addClass('pe-none');
    }

    private finishPolishing() {
        var self = this;

        console.log('Finish polishing');

        self.polishingInProgressContainer.addClass('d-none');
        self.linesTable.parent().removeClass('pe-none');
    }

    private removeFirstCharactersFromString(amountOfCharactersToRemove : number, description : string) : string {

        description = description.substring(amountOfCharactersToRemove, description.length);
        description = description.trim();

        return description;
    }

    private removeEverythingBeforeOrAfterCharactersFromString(removeOption : string, characterToFind : string, description : string) : string {
        if(characterToFind == undefined || characterToFind.length == 0) {
            return description;
        }

        var firstOccurrence = description.indexOf(characterToFind);
        if(firstOccurrence == -1) {
            return description;
        }

        if(removeOption == 'before') {
            description = description.substring(firstOccurrence, description.length);
        }
        else if(removeOption == 'after') {
            description = description.substring(0, firstOccurrence+(characterToFind.length));
        }

        description = description.trim();

        return description;
    }    
    
    private replaceTextFromString(textToReplace : string, replacingText : string, description : string) : string {
        var escaped = textToReplace.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

        var regex = new RegExp(escaped.replace(/\s+/g, '\\s+'), 'g');

        description = description.replace(regex, replacingText);

        description = description.trim();

        return description;
    } 

    private removeUppercaseExceptFirstLetter(description : string) : string {
        description =  description.split(' ').map(item => item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()).join(' ');

        description = description.trim();

        return description;
    }    
    
    private onlyKeepTheFirstSentence(description : string) : string {
        description = description.trim();

        var firstLineMatch = description.match(/([\s\S]*?[\.!?])(\s|$)/);
        if(firstLineMatch && firstLineMatch[1]) {
            return firstLineMatch[1].trim();
        }

        var firstLine = description.split(/\r?\n/)[0] || description;

        return firstLine.trim();
    }    
    
    private removeDuplicateSentences(description : string) : string {
        description = description.trim();

        var parts = description.split(/(?<=[\.!?])\s+/);
        var seen = new Set();
        var result : string[] = [];
        for(let p of parts) {
            var norm = p.replace(/\s+/g,' ').trim().toLowerCase();
            if(!norm) continue;
            if(!seen.has(norm)) {
                seen.add(norm);
                result.push(p.trim());
            }
        }

        return result.join(' ');
    }

    private removeRepeatedPhrases(description : string) : string {
        description = description.trim();

        var prev;
        var result = description;
        var re = /(\b(?:[A-Za-z0-9\/\-\.\&\%]{1,}\s+){1,}\b)\s+\1/gi;
        do {
            prev = result;
            result = result.replace(re, '$1');
        } while(result !== prev);

        result = result.replace(/\b(\w+)\s+\1\b/gi, '$1');
        return result;
    }



    private insertFieldAtLocationWithSeperator(fieldNameToInsert : string, locationToInsert: string, seperator: string, tableRow : JQuery<HTMLElement>, description : string) : string {
        const trimmedDescription = description.trim();

        const fieldValue = String(
            tableRow
                .find(`input[name$=".${fieldNameToInsert}"]`)
                .first()
                .val() ?? ""
        ).trim();

        if (!fieldValue) {
            return trimmedDescription;
        }

        if (!trimmedDescription) {
            return fieldValue;
        }

        if (locationToInsert === "before") {
            return `${fieldValue}${seperator}${trimmedDescription}`;
        }

        return `${trimmedDescription}${seperator}${fieldValue}`;
    }

    //#endregion

    private updateTotalSelectedCount() {
        var self = this;

        self.amountOfSelectedLinesTextSpan.text(self.linesTableBody.find('input[type="checkbox"]:checked').length)
    }

    private checkboxChanged() {
        var self = this;

        var allChecked = self.linesTableBody.find('input[type="checkbox"]:checked').length == self.linesTableBody.find('input[type="checkbox"]').length;
        
        self.selectAllLinesCheckbox.prop('checked', allChecked);
        self.updateTotalSelectedCount();
    }


}